import accessModule from "AccessModule";
accessModule("env_dates", process.env);

const services = [
  {
    id: "app",
  },
  {
    id: "upload",
  },
  {
    id: "auth",
  },
  {
    id: "education",
  },
  {
    id: "community",
  },
  {
    id: "mmproxy",
  },
];

export default services.map((service) => {
  return {
    id: service.id,
    baseURL:
      process.env["VUE_APP_" + service.id.toUpperCase() + "_HOST"] ||
      process.env["VUE_APP_APP_HOST"],
    ...require("API/" + service.id + "-api.json"),
  };
});
